/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Tool_Bulk_Public_Access_WarningInputs */



/**
* | output |
* | --- |
* | "Some of these also switch off a public share link or custom domain for good — restoring the app does not bring it back." |
*
* @param {Chat_Tool_Bulk_Public_Access_WarningInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_tool_bulk_public_access_warning = /** @type {((inputs?: Chat_Tool_Bulk_Public_Access_WarningInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Bulk_Public_Access_WarningInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Einige davon schalten außerdem einen öffentlichen Freigabelink oder eine eigene Domain endgültig ab — das Wiederherstellen der App holt sie nicht zurück.")
	return /** @type {LocalizedString} */ ("Some of these also switch off a public share link or custom domain for good — restoring the app does not bring it back.")
});